// Верхняя граница ручного ввода количества: защита от опечатки вроде лишних нулей
export const MAX_QUANTITY = 9999;

// Число, вписанное руками: целое от 1 до MAX_QUANTITY, иначе null
export function parseQuantity(value) {
  const quantity = Math.floor(Number(value));
  return Number.isFinite(quantity) && quantity >= 1 && quantity <= MAX_QUANTITY ? quantity : null;
}
